import React, { useState, useEffect, useCallback } from 'react';
import { Radio } from 'antd';
import { apiHolder } from 'api';
import { ENCODING_MAP } from '@web-mail/common/constant';
import './index.scss';
const eventApi = apiHolder.api.getEventApi();
const OPTIONS = Object.keys(ENCODING_MAP).reduce((total, key) => {
    total.push({
        value: key,
        label: ENCODING_MAP[key],
    });
    return total;
}, []);
const MailEncodingComp = ({ close, encodingValue, mid, account }) => {
    const [value, setValue] = useState('default');
    useEffect(() => {
        setValue(encodingValue || 'default');
    }, [encodingValue]);
    const onChange = (e) => {
        setValue(e.target.value);
        console.log(mid);
        changeEncodingDebounce(mid, e.target.value);
        if (close) {
            close();
        }
    };
    const changeEncodingDebounce = useCallback((mid, encoding) => {
        eventApi.sendSysEvent({
            eventName: 'mailMenuOper',
            eventStrData: 'mailEncoding',
            eventData: {
                mid,
                encoding,
                account,
            },
        });
    }, []);
    return (React.createElement(Radio.Group, { options: OPTIONS, value: value, onChange: onChange, className: "mailEncodingContainer" }, OPTIONS.map(v => (React.createElement(Radio, { value: v.value, key: v.value }, v.label)))));
};
export default MailEncodingComp;
